import { FC, useCallback, useEffect, useState } from 'react'
import { useIntl } from 'react-intl'
import { useLocation, useNavigate } from 'react-router'

import { Menu } from 'antd'

import { headerItems } from './index'

const Header: FC = () => {
  const navigate = useNavigate()
  const { pathname } = useLocation()
  const { formatMessage } = useIntl()
  const onClick = useCallback((it: { key: string }) => navigate(it.key), [navigate])
  const [activeKey, setActiveKey] = useState(pathname)
  useEffect(() => {
    const chunks = pathname.split('/')
    setActiveKey([chunks[0], chunks[1]].join('/'))
  }, [pathname])
  return (
    <Menu
      selectedKeys={[activeKey]}
      theme={'dark'}
      triggerSubMenuAction={'click'}
      mode={'horizontal'}
      style={{ background: 'transparent', width: 'calc(100% - 200px - 64px)' }}
      items={headerItems.map((it) => ({
        ...it,
        label: formatMessage({ id: it.label }),
        onClick,
      }))}
    />
  )
}
export { Header }
